export const ledgerPaymentStatusColors = {
  "Reconciled": "green",
  "Reconciled manually": "yellow",
  "Allocated": "blue",
  "Over-allocated": "red",
  "Reconciling": "blue",
  "Change detected": "yellow",
  "Error": "red",
  "Part-reconciled": "yellow"
}

export const payoutStatusColors = {
  "In-transit": "yellow",
  "InTransit": "yellow",
  "Paid": "green",
  "Refunded": "zinc",
  "Failed": "red",
}